import { useState, useEffect, useCallback } from "react";
import { TrendingUp, X, ChevronLeft, ChevronRight } from "lucide-react";

/**
 * Results gallery for the /get-found sales page. Shows all 51 result images in
 * a scrollable grid, each clickable to expand in a lightbox with keyboard +
 * on-screen arrow navigation. Kept in its own module so the sales page can
 * import it without pulling the rest of the section components.
 */

export function Eyebrow({ children }: { children: React.ReactNode }) {
  return (
    <span className="font-mono text-xs uppercase tracking-[0.25em] text-[#b85736] font-bold">
      {children}
    </span>
  );
}

export function SectionHeading({
  children,
  className = "text-white",
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <h2
      className={`font-heading text-3xl md:text-4xl font-extrabold uppercase tracking-tight leading-tight ${className}`}
    >
      {children}
    </h2>
  );
}

const RESULT_IMAGES = [
  "https://assets.cdn.filesafe.space/rizeckkMPBYZT9pK9UjX/media/6abe93b03df2ee8bbe3420ec.png",
  "https://assets.cdn.filesafe.space/rizeckkMPBYZT9pK9UjX/media/6abe939aff15fe1a4a1ed892.png",
  "https://assets.cdn.filesafe.space/rizeckkMPBYZT9pK9UjX/media/6abe939a8807113c2d228118.png",
  "https://assets.cdn.filesafe.space/rizeckkMPBYZT9pK9UjX/media/6abe93593df2ee8bbe341713.png",
  "https://assets.cdn.filesafe.space/rizeckkMPBYZT9pK9UjX/media/6abe933817f6f30939b5d6e8.png",
  "https://assets.cdn.filesafe.space/rizeckkMPBYZT9pK9UjX/media/69e93e21a48992f689b5b62a.png",
  "https://assets.cdn.filesafe.space/rizeckkMPBYZT9pK9UjX/media/69e93e21a48992f689b5b629.png",
  "https://assets.cdn.filesafe.space/rizeckkMPBYZT9pK9UjX/media/69e93e21b0e5e2bb7feb73b1.png",
  "https://assets.cdn.filesafe.space/rizeckkMPBYZT9pK9UjX/media/69d710103dd00cb232bc870a.png",
  "https://assets.cdn.filesafe.space/rizeckkMPBYZT9pK9UjX/media/69d71000eaae8b1b71f1d979.jpg",
  "https://assets.cdn.filesafe.space/rizeckkMPBYZT9pK9UjX/media/69d70ff9a7dcb4cff067b936.png",
  "https://assets.cdn.filesafe.space/rizeckkMPBYZT9pK9UjX/media/69d70ff9eaae8b1b71f1d851.png",
  "https://assets.cdn.filesafe.space/rizeckkMPBYZT9pK9UjX/media/69d70fed3dd00cb232bc81d0.png",
  "https://assets.cdn.filesafe.space/rizeckkMPBYZT9pK9UjX/media/69d70feda7dcb4cff067b7aa.png",
  "https://assets.cdn.filesafe.space/rizeckkMPBYZT9pK9UjX/media/69d70feda64a04ba1501e1aa.png",
  "https://assets.cdn.filesafe.space/rizeckkMPBYZT9pK9UjX/media/69d70fede033d6ce5853a5cf.png",
  "https://assets.cdn.filesafe.space/rizeckkMPBYZT9pK9UjX/media/69d70fedebf1a6084352c009.png",
  "https://assets.cdn.filesafe.space/rizeckkMPBYZT9pK9UjX/media/6983ebf22dd985d97d1d327f.png",
  "https://assets.cdn.filesafe.space/rizeckkMPBYZT9pK9UjX/media/6983ebf2e4411b16294c5984.jpg",
  "https://assets.cdn.filesafe.space/rizeckkMPBYZT9pK9UjX/media/6983ebf2d017c3469c83a97f.jpg",
  "https://assets.cdn.filesafe.space/rizeckkMPBYZT9pK9UjX/media/6983ebf2d017c3c35983a97e.jpg",
  "https://assets.cdn.filesafe.space/rizeckkMPBYZT9pK9UjX/media/6983ebf20708e48340ba6049.webp",
  "https://assets.cdn.filesafe.space/rizeckkMPBYZT9pK9UjX/media/6983ebf2a54afa99e9adff92.jpg",
  "https://assets.cdn.filesafe.space/rizeckkMPBYZT9pK9UjX/media/6983ebf20708e4d1daba6048.jpg",
  "https://assets.cdn.filesafe.space/rizeckkMPBYZT9pK9UjX/media/6983ebf20a7fd1b1625a5193.jpg",
  "https://assets.cdn.filesafe.space/rizeckkMPBYZT9pK9UjX/media/6983ebf2e4411b62464c5985.jpg",
  "https://assets.cdn.filesafe.space/rizeckkMPBYZT9pK9UjX/media/6983e726e4411b28054bca04.png",
  "https://assets.cdn.filesafe.space/rizeckkMPBYZT9pK9UjX/media/6983e6970708e40f45b9badd.png",
  "https://assets.cdn.filesafe.space/rizeckkMPBYZT9pK9UjX/media/6983e6970708e4a4dab9bade.png",
  "https://assets.cdn.filesafe.space/rizeckkMPBYZT9pK9UjX/media/6983e6970708e4fd7bb9badb.png",
  "https://assets.cdn.filesafe.space/rizeckkMPBYZT9pK9UjX/media/6983e6970a7fd1a7ad59a8df.png",
  "https://assets.cdn.filesafe.space/rizeckkMPBYZT9pK9UjX/media/6983e6970708e425b9b9badc.png",
  "https://assets.cdn.filesafe.space/rizeckkMPBYZT9pK9UjX/media/6983e697a54afadbb3ad5e60.png",
  "https://assets.cdn.filesafe.space/rizeckkMPBYZT9pK9UjX/media/6983e697e4411b466c4bb9f1.png",
  "https://assets.cdn.filesafe.space/rizeckkMPBYZT9pK9UjX/media/6983e69726ea64d143b5ec59.png",
  "https://assets.cdn.filesafe.space/rizeckkMPBYZT9pK9UjX/media/6983e697a54afa270ead5e63.png",
  "https://assets.cdn.filesafe.space/rizeckkMPBYZT9pK9UjX/media/6983e6971dfc020550670224.png",
  "https://assets.cdn.filesafe.space/rizeckkMPBYZT9pK9UjX/media/6983e6977732b57edf451063.png",
  "https://assets.cdn.filesafe.space/rizeckkMPBYZT9pK9UjX/media/6983e6972dd98589ea1c911e.png",
  "https://assets.cdn.filesafe.space/rizeckkMPBYZT9pK9UjX/media/6983e69718c335775541cd2c.png",
  "https://assets.cdn.filesafe.space/rizeckkMPBYZT9pK9UjX/media/6983e6977732b59745451062.png",
  "https://assets.cdn.filesafe.space/rizeckkMPBYZT9pK9UjX/media/6983e697e4411b709e4bb9f0.png",
  "https://assets.cdn.filesafe.space/rizeckkMPBYZT9pK9UjX/media/6983e697a54afa5f35ad5e62.png",
  "https://assets.cdn.filesafe.space/rizeckkMPBYZT9pK9UjX/media/6983e697a54afa83bbad5e5f.png",
  "https://assets.cdn.filesafe.space/rizeckkMPBYZT9pK9UjX/media/6983e697e4411b809d4bb9ee.png",
  "https://assets.cdn.filesafe.space/rizeckkMPBYZT9pK9UjX/media/6983e6972dd9857d831c911f.png",
  "https://assets.cdn.filesafe.space/rizeckkMPBYZT9pK9UjX/media/6983e697e4411b954f4bb9ef.png",
  "https://assets.cdn.filesafe.space/rizeckkMPBYZT9pK9UjX/media/6983e6970a7fd1f05959a8e2.png",
  "https://assets.cdn.filesafe.space/rizeckkMPBYZT9pK9UjX/media/6983e697e4411b62784bb9ed.png",
  "https://assets.cdn.filesafe.space/rizeckkMPBYZT9pK9UjX/media/6983e697a54afabd16ad5e61.png",
  "https://assets.cdn.filesafe.space/rizeckkMPBYZT9pK9UjX/media/6983e6970a7fd1e25359a8e0.png",
];

function Lightbox({
  images,
  index,
  onClose,
  onPrev,
  onNext,
}: {
  images: string[];
  index: number;
  onClose: () => void;
  onPrev: () => void;
  onNext: () => void;
}) {
  const handleKey = useCallback(
    (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
      if (e.key === "ArrowLeft") onPrev();
      if (e.key === "ArrowRight") onNext();
    },
    [onClose, onPrev, onNext],
  );
  useEffect(() => {
    window.addEventListener("keydown", handleKey);
    document.body.style.overflow = "hidden";
    return () => {
      window.removeEventListener("keydown", handleKey);
      document.body.style.overflow = "";
    };
  }, [handleKey]);

  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center bg-black/90 backdrop-blur-sm p-4"
      onClick={onClose}
    >
      <button
        onClick={(e) => {
          e.stopPropagation();
          onClose();
        }}
        className="absolute top-4 right-4 text-white/70 hover:text-white transition-colors"
        aria-label="Close"
      >
        <X className="h-8 w-8" />
      </button>
      <button
        onClick={(e) => {
          e.stopPropagation();
          onPrev();
        }}
        className="absolute left-2 md:left-6 text-white/70 hover:text-white transition-colors"
        aria-label="Previous"
      >
        <ChevronLeft className="h-10 w-10" />
      </button>
      <img
        src={images[index]}
        alt={`Result ${index + 1}`}
        onClick={(e) => e.stopPropagation()}
        className="max-h-[88vh] max-w-[92vw] object-contain rounded-lg"
      />
      <button
        onClick={(e) => {
          e.stopPropagation();
          onNext();
        }}
        className="absolute right-2 md:right-6 text-white/70 hover:text-white transition-colors"
        aria-label="Next"
      >
        <ChevronRight className="h-10 w-10" />
      </button>
      <span className="absolute bottom-4 left-1/2 -translate-x-1/2 font-mono text-xs text-white/60 tracking-wider">
        {index + 1} / {images.length}
      </span>
    </div>
  );
}

export function ResultsSection() {
  const [lightboxIndex, setLightboxIndex] = useState<number | null>(null);

  const close = () => setLightboxIndex(null);
  const prev = () =>
    setLightboxIndex((i) =>
      i === null ? i : (i - 1 + RESULT_IMAGES.length) % RESULT_IMAGES.length,
    );
  const next = () =>
    setLightboxIndex((i) => (i === null ? i : (i + 1) % RESULT_IMAGES.length));

  return (
    <section className="bg-[#111118] border-y border-white/10 px-5 md:px-8 py-16 md:py-24">
      <div className="max-w-5xl mx-auto">
        <div className="flex items-center gap-2">
          <TrendingUp className="h-5 w-5 text-[#b85736]" />
          <Eyebrow>Real Results</Eyebrow>
        </div>
        <SectionHeading className="text-white mt-2">
          Rankings that move the needle
        </SectionHeading>
        <p className="mt-4 max-w-2xl text-white/60 text-sm md:text-base">
          The exact outcomes the Get Found system produces — from map pack
          dominance to AI search visibility. Scroll through more results below.
          Click any image to expand it.
        </p>
        <div className="mt-10 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3 md:gap-4">
          {RESULT_IMAGES.map((src, i) => (
            <button
              key={src}
              onClick={() => setLightboxIndex(i)}
              className="group relative overflow-hidden rounded-lg border border-white/10 bg-black/40 focus:outline-none focus:ring-2 focus:ring-[#b85736]"
              aria-label={`Expand result ${i + 1}`}
            >
              <div className="aspect-square overflow-hidden">
                <img
                  src={src}
                  alt={`Result ${i + 1}`}
                  loading="lazy"
                  className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-105"
                />
              </div>
              <span className="absolute bottom-1.5 right-1.5 font-mono text-[9px] text-white/70 bg-black/50 px-1.5 py-0.5 rounded">
                {i + 1}
              </span>
            </button>
          ))}
        </div>
      </div>
      {lightboxIndex !== null && (
        <Lightbox
          images={RESULT_IMAGES}
          index={lightboxIndex}
          onClose={close}
          onPrev={prev}
          onNext={next}
        />
      )}
    </section>
  );
}
